import { useMutation } from "react-query";
import ApplicationUpdateActions from "../../services/molecules/OBPS/ApplicationUpdateActions";

const useApplicationActions = (tenantId ,formType) => {
  return useMutation((applicationData) => ApplicationUpdateActions(applicationData, tenantId,formType));
};

export default useApplicationActions;
